import { m } from 'framer-motion';
import { useState, useCallback, useEffect } from 'react';
// @mui
import Tab from '@mui/material/Tab';
import { PiBell } from 'react-icons/pi';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import List from '@mui/material/List';

import Stack from '@mui/material/Stack';
import Badge, { badgeClasses } from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import { redirectDocument, useNavigate } from 'react-router';
import { paths } from 'src/routes/paths';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// hooks
import axios, { endpoints } from 'src/utils/axios';
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// _mock
import { _notifications } from 'src/_mock';
// components
import { useAuthContext } from 'src/auth/hooks';
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { varHover } from 'src/components/animate';
//
import NotificationItem from './notification-item';
import noDataImage from '../../../defaultimg/Bell.png';

// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'all',
    label: 'All',
    count: 22,
  },
  {
    value: 'unread',
    label: 'Unread',
    count: 12,
  },
  {
    value: 'archived',
    label: 'Archived',
    count: 10,
  },
];

// ----------------------------------------------------------------------
const NoDataComponent = () => (
  <div style={{ textAlign: 'center', padding: '16px', backgroundColor: 'transparent' }}>
    <img src={noDataImage} alt="No Data Found" style={{ maxWidth: '100%', height: '180px' }} />
    <Typography variant="h6" color="text.secondary" sx={{ mt: 1 }}>
      No Notifications Found
    </Typography>
  </div>
);

export default function NotificationsPopover() {
  const drawer = useBoolean();
  const auth = useAuthContext();
  const smUp = useResponsive('up', 'sm');
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState('all');

  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);

  const [notifications, setNotifications] = useState();

  const totalUnRead = notifications?.filter((item) => item.isUnRead === true).length;

  const fetchData = async () => {
    try {
      const response = await axios.post(`${endpoints.announcement.getNotif}${auth.user.id}`);
      if (response && response.data) {
        setNotifications(response.data.announcements);
      
        
      }
    } catch (err) {
      // // console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectToView = (row) => {
    const roleType = auth?.user?.roleType;
    const routeWithState = { state: row };
    navigate(paths.dashboard.studentannouncement.root, routeWithState);
    fetchData();
  };

  const handleMarkAllAsRead = () => {
    setNotifications(
      notifications?.map((notification) => ({
        ...notification,
        isUnRead: false,
      }))
    );
  };

  const renderHead = (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Notifications
      </Typography>
    </Stack>
  );

  const renderList = (
    <>
      <Scrollbar>
        <List disablePadding>
          {notifications?.map((notification) => (
            <NotificationItem
              key={notification.announcementId}
              notification={notification}
              onClick={() => {
                drawer.onFalse();
                redirectToView(notifications);
              }}
            />
          ))}
        </List>
      </Scrollbar>
      <Box sx={{ p: 1 }}>
        <Divider sx={{ borderStyle: 'dashed', borderColor: '#e2e1ff' }} />
        <Button
          fullWidth
          size="large"
          onClick={() => {
            drawer.onFalse();
            redirectToView(notifications);
          }}
        >
          View All
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <Badge
        color="error"
        variant="dot"
        invisible={!notifications || notifications.length === 0}
        sx={{
          mr: 2,
          [`& .${badgeClasses.badge}`]: {
            top: 8,
            right: 8,
          },
        }}
      >
        <Box component={m.div}>
          <IconButton
            component={m.button}
            whileTap="tap"
            whileHover="hover"
            variants={varHover(1.05)}
            aria-label="notifications"
            sx={{
              width: 40,
              height: 40,
            }}
            onClick={drawer.onTrue}
            color={drawer.value ? 'primary' : 'default'}
          >
            <Box sx={{ mt: 1, mr: 2, ml: 1, color: '#7068FF' }}>
              <PiBell style={{ fontSize: '1.5rem' }} />
            </Box>
          </IconButton>
        </Box>
      </Badge>

      <Drawer
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 1, maxWidth: 350 },
        }}
      >
        {renderHead}

        <Divider sx={{ borderStyle: 'dashed', borderColor: '#e2e1ff', mb: 2 }} />

        {/* <Divider /> */}

        {/* {renderList} */}
        {notifications && notifications.length > 0 ? renderList : <NoDataComponent />}
      </Drawer>
    </>
  );
}
